import { render, staticRenderFns } from "./StatistiquesForm.vue?vue&type=template&id=da2ade6c&"
import script from "./StatistiquesForm.vue?vue&type=script&lang=js&"
export * from "./StatistiquesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatistiquesForm.vue"
export default component.exports